module.exports = __webpack_public_path__ + "img/W-C93.9e62c04a.jpg";